import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CardGroup, Container } from "react-bootstrap";
import ComponentSousTitle from "../../layout/ComponentSousTitle";
import ComponentLoader from "../../layout/ComponentLoader";
import { apiGetLastContribsOnEspacesColidee } from "../../../api/ApiColidee";
import { apiGetProcesses } from "../../../api/ApiProcess";
import ComponentContribution from "./ComponentContribution";
import { MdAddCircleOutline, MdRemoveCircleOutline } from "react-icons/md";

const BlocIdeesDuMoment = () => {
  const { t } = useTranslation();
  const nbrContributionsMini = 6;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [reduceContributions, setReduceContributions] = useState([]);
  const [contributions, setContributions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const recupDatas = async () => {
    setLoader(true);
    // récupération des dernieres contribs sur tous les espaces autorisés
    // récupération Espaces Colidée
    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);

    if (ReduxInstance.espacePrincipalColidee) {
      espacesSouhaites = espacesSouhaites.filter(
        (item) => parseInt(item) !== ReduxInstance.espacePrincipalColidee
      );
    }

    const form = new FormData();
    form.append("espacesSouhaites", espacesSouhaites.join(","));
    const res = await apiGetLastContribsOnEspacesColidee(ReduxToken, form);
    setContributions(res.data);

    if (res.data.length) {
      const resDataCopy = [...res.data];
      resDataCopy.length = nbrContributionsMini;
      setReduceContributions(resDataCopy);
    }

    setLoader(false);
  };

  const toggleContributions = (etat) => {
    setShowAll(etat);
    const resDataCopy = [...contributions];

    if (!etat) {
      setTimeout(function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
      resDataCopy.length = nbrContributionsMini;
    }
    setReduceContributions(resDataCopy);
  };

  useEffect(() => {
    setShowAll(false);
    recupDatas();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <Container fluid>
          {reduceContributions.length > 0 && (
            <>
              <ComponentSousTitle
                nom={t("public.filtres.filtre10")}
                overflowID={"overflowContributions"}
                overflowDeplieAuDepart={true}
              />
              <CardGroup className="disableOverflowContent" id={"overflowContributions"}>
                {reduceContributions.map((contribution, index) => (
                  <React.Fragment key={"contribution_" + index}>
                    <ComponentContribution contributionObject={contribution} />

                    {showAll && (index === 15 || index === 30 || index === 49) && (
                      <div
                        role="button"
                        onClick={(e) => toggleContributions(false)}
                        className="seeMoreContributions d-flex align-items-center justify-content-center m-2"
                      >
                        <MdRemoveCircleOutline size="2em" />
                      </div>
                    )}
                  </React.Fragment>
                ))}
                {!showAll && contributions.length > nbrContributionsMini && (
                  <div
                    role="button"
                    onClick={(e) => toggleContributions(true)}
                    className="seeMoreContributions d-flex align-items-center justify-content-center m-2"
                  >
                    <MdAddCircleOutline size="2em" />
                  </div>
                )}
              </CardGroup>
            </>
          )}
        </Container>
      )}
    </>
  );
};
export default BlocIdeesDuMoment;
